import { useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import CONSTANTS from '../constants/constants';

const useReCaptcha = ({ onVerification, onExpiry, action, resetCaptcha }) => {
    const globalState = useSelector((state) => state);

    var REACT_APP_CAPTCHA_KEY;
    if (process.env.NODE_ENV === 'development') {
        REACT_APP_CAPTCHA_KEY = CONSTANTS.CAPTCHA_KEY;
    } else {
        REACT_APP_CAPTCHA_KEY = globalState.beneDetails.captchaConfig.recaptchaKey;
    }
    console.log('Logging REACT_APP_CAPTCHA_KEY from useReCaptcha hook', REACT_APP_CAPTCHA_KEY);
    const isFirstFetch = useRef(true);

    const onVerify = useCallback(
        (response) => {
            onVerification && onVerification(response);
        },
        [onVerification]
    );

    useEffect(() => {
        if (resetCaptcha) {
            try {
                window.grecaptcha.enterprise.reset();
            } catch (e) {}
        }
    }, [resetCaptcha]);

    const expiry = useCallback(() => {
        onExpiry();
    }, [onExpiry]);

    const errorCallback = () => {
        alert('Error while loading captcha, Please reload the page');
    };


    useEffect(() => {
        if (isFirstFetch.current) {
            try {
                window.grecaptcha.enterprise.render('recaptcha', {
                    sitekey: REACT_APP_CAPTCHA_KEY,
                    theme: 'light',
                    callback: onVerify,
                    'expired-callback': expiry,
                    'error-callback': errorCallback,
                });
            } catch (e) {}
            isFirstFetch.current = false;
        }
    }, [REACT_APP_CAPTCHA_KEY, onVerify, expiry, action]);
};

export default useReCaptcha;
